<template>
	<div class="main-map-wrap" :style="isNngdjt ? 'z-index: 0' : ''">
		<div class="data-bus">
			<input id="main-map-poi-search-input"/>
			<button @click="onClickInitCompass">触发陀螺仪初始化</button>
		</div>
		<div id="main-map" :style="`height: calc(100vh + ${mapMargins[2] - 40}px);top: -${mapMargins[2] - 40}px;bottom: 0;`"></div>
	</div>
</template>

<script>
import {mapGetters,mapMutations} from 'vuex';
import busPic from '../../assets/img-v2/ic_map_bus.png';
import posMarkerPic from '../../assets/img-v2/ic_map_pos.png';
import posMarkerPic2 from '../../assets/img-v2/ic_map_pos2.png';
import onMarkerPic from '../../assets/img-v2/ic_map_on.png';
import offMarkerPic from '../../assets/img-v2/ic_map_off.png';
import userPosPic from '../../assets/img/pos.png';
import userPosPicIos from '../../assets/img/user-pos.png';
import nothingPic from '../../assets/img/nothing.png';
import stopPic from '../../assets/img-v2/ic_map_stop.png';
import stopPicNavi from '../../assets/img/icon-stop-navi.png';
import stopPicGreen from '../../assets/img-v2/ic_map_stop_green.png';
import {calcTimeDiff, delay, isIos, marsToBaidu, wait} from "../../utils";

let map;
let eventBinded = false;
let userPosCtrl;
let fitViewCtrl;
let o = new BMapGL.Point(0, 0);
let sizeOne = new BMapGL.Size(1, 1);

const stopIcon = new BMapGL.Icon(stopPic, new BMapGL.Size(30, 30));
const stopIconGreen = new BMapGL.Icon(stopPicGreen, new BMapGL.Size(30, 30));
const naviStopIcon = new BMapGL.Icon(stopPicNavi, new BMapGL.Size(30, 30));

const singleMarkers = {
	user: {
		marker: null,
		setter: 'setOverlayUserPosMarker',
		icon: new BMapGL.Icon(isIos() ? userPosPicIos : userPosPic, new BMapGL.Size(30, 30)),
		initIcon: new BMapGL.Icon(nothingPic, sizeOne),
		offset: null,
		zIndex: 50,
	},
	onStop: {
		marker: null,
		setter: 'setOverlayOnStopMarker',
		icon: new BMapGL.Icon(posMarkerPic, new BMapGL.Size(20, 34)),
		initIcon: new BMapGL.Icon(nothingPic, sizeOne),
		offset: new BMapGL.Size(-1, -13),
		zIndex: 40,
	},
	offStop: {
		marker: null,
		setter: 'setOverlayOffStopMarker',
		icon: new BMapGL.Icon(posMarkerPic, new BMapGL.Size(20, 34)),
		initIcon: new BMapGL.Icon(nothingPic, sizeOne),
		offset: new BMapGL.Size(-1, -13),
		zIndex: 40,
	},
	bus: {
		marker: null,
		setter: 'setOverlayBusMarker',
		icon: new BMapGL.Icon(busPic, new BMapGL.Size(37, 47)),
		initIcon: new BMapGL.Icon(nothingPic, sizeOne),
		offset: null,
		zIndex: 100,
	},
	runningOnStop: {
		marker: null,
		setter: 'setOverlayRunningOnStopMarker',
		icon: new BMapGL.Icon(posMarkerPic, new BMapGL.Size(20, 34)),
		initIcon: new BMapGL.Icon(nothingPic, sizeOne),
		offset: new BMapGL.Size(-1, -13),
		zIndex: 40,
	},
	runningOffStop: {
		marker: null,
		setter: 'setOverlayRunningOffStopMarker',
		icon: new BMapGL.Icon(posMarkerPic, new BMapGL.Size(20, 34)),
		initIcon: new BMapGL.Icon(nothingPic, sizeOne),
		offset: new BMapGL.Size(-1, -13),
		zIndex: 40,
	},
};

export default {
	name: 'mainMap',
	data() {
		return {
			compassHeading: undefined,
      clickLabel: {
        stopId: null,
        label: null
      }, // 点击label
      polygon: null,
			isNngdjt: isIos() // 是否是ios, 解决ios下z-index为-1的问题
		};
	},
	computed: {
		...mapGetters({
			mapMargins: 'mapMargins',
			mapMarginsBottom: 'mapMarginsBottom',
			mapMode: 'mapMode',
			mapFitViewMode: 'mapFitViewMode',
			areas: 'dataAreas',
			overlays: 'overlays',
			dataSource: 'dataSource',
			stops: 'dataStops',
			userPos: 'dataUserPos',
			onStop: 'dataOnStop',
			offStop: 'dataOffStop',
			busPos: 'dataBusPos',
			runningOnStop: 'dataRunningOnStop',
			runningOffStop: 'dataRunningOffStop',
			runningRoute: 'dataRunningRoute', // 脊线源数据
			runningNaviStop: 'dataRunningNaviStop', // 经停点源数据
			areaCenterPos: 'dataAreaCenterPos',
			overlayOnStopMarker: 'overlayOnStopMarker',
			overlayOffStopMarker: 'overlayOffStopMarker',
			overlayOnStopLabel: 'overlayOnStopLabel',
			overlayOffStopLabel: 'overlayOffStopLabel',
			overlayRunningOnStopMarker: 'overlayRunningOnStopMarker',
			overlayRunningOffStopMarker: 'overlayRunningOffStopMarker',
			overlayRunningOnStopLabel: 'overlayRunningOnStopLabel',
			overlayRunningOffStopLabel: 'overlayRunningOffStopLabel',
			overlayPosingLabel: 'overlayPosingLabel',
			overlayBusMarker: 'overlayBusMarker',
			overlayRunningPolyline: 'overlayRunningPolyline', // 脊线polyline
			overlayRunningNaviStopMarker: 'overlayRunningNaviStopMarker', // 经停点markers
			mapVisible: 'stateMapVisible',
			stateOnStopDraggable: 'stateOnStopDraggable',
			stateOffStopDraggable: 'stateOffStopDraggable',
			stateMapRenderFlag: 'stateRenderFlag',
			stateMapDraggingOn: 'stateDraggingOn',
			stateMapDraggingOff: 'stateDraggingOff',
			currentAreaIndex: 'run/currentAreaIndex',
			stopType: 'poi/stopType',
		  currentArea: 'run/currentArea',
			isHubArea: "run/isHubArea", // 是否枢纽站模式
      isFromHub: "run/isFromHub", // 是否从枢纽站出发
			hideUserPosCtrl: 'hideUserPosCtrl',
			fitViewToUserPos: 'fitViewToUserPos',
			removeMarkerLabel: 'removeMarkerLabel',
		}),
		onStopId() {
			return this.onStop ? this.onStop.id : null;
		}
	},
	watch: {
		'$route': {
			handler() {
				this.$nextTick(() => {
					this.onStopTrigger(this.onStop);
				});
			}
		},
		currentAreaIndex() {
			// 清空区域显示
			this.$MapService.removeOverlayAreaPolygons();
			// 清空运营站点显示
			this.$MapService.removeOverlayStopMarkers();
			this.$MapService.removeOverlayStopMarkers();
			// 清空上车站显示
			this.$MapService.removeOverlayOnStopMarker();
			this.$MapService.setMapDataOnStop(null);
			// 清空下车站显示
			this.$MapService.removeOverlayOffStopMarker();
			this.$MapService.setMapDataOffStop(null);
			this.$nextTick(() => {
				this.$MapService.setFitView();
			});
		},
		stateMapRenderFlag: {
			handler() {
				if (map) {
					// 这里清空地图上的所有覆盖物
					map.clearOverlays();
					// 重新绘制图标元素
					this.createSingleMarkers();
					if (this.$MapService.isMapModeRunning()) { // 运行中模式
						// 清空区域显示
						this.$MapService.removeOverlayAreaPolygons();
						// 清空运营站点显示
						this.$MapService.removeOverlayStopMarkers();
						// 清空上车站显示
						this.$MapService.removeOverlayOnStopMarker();
						// 清空下车站显示
						this.$MapService.removeOverlayOffStopMarker();
						// 触发上车站显示
						this.runningOnStopTrigger(this.runningOnStop);
						// 触发下车站显示
						this.runningOffStopTrigger(this.runningOffStop);
            // 脊线
            this.runningRouteTrigger(this.runningRoute)
            // 经停点
				    this.runningNaviStopTrigger(this.runningNaviStop);
					} else { // 普通模式
						// 显示区域
						this.$MapService.setOverlayAreaPolygons(Array.from(this.areas).map(this.drawArea));
            this.drawArea2()
						// 显示站点
						this.$MapService.setOverlayStopMarkers(Array.from(this.stops).map(this.drawStop));
						// 清空车辆显示
						this.$MapService.removeOverlayBusMarker();
						// 清空运行中上车站显示
						this.$MapService.removeOverlayRunningOnStopMarker();
						// 清空运行中下车站显示
						this.$MapService.removeOverlayRunningOffStopMarker();
						// 触发上车站显示
						this.onStopTrigger(this.onStop);
						// 触发下车站显示
						this.offStopTrigger(this.offStop);
            this.removeRunningRoute();
            this.removeRunningNaviStop();
					}
					this.userPosTrigger(this.userPos);
				}
				// this.$forceUpdate();
			}
		},
		mapMode() {
			if (map) {
				// 重新绘制图标元素
				this.createSingleMarkers();
				if (this.$MapService.isMapModeRunning()) { // 运行中模式
					// 清空区域显示
					this.$MapService.removeOverlayAreaPolygons();
					// 清空运营站点显示
					this.$MapService.removeOverlayStopMarkers();
					// 清空上车站显示
					this.$MapService.removeOverlayOnStopMarker();
					// 清空下车站显示
					this.$MapService.removeOverlayOffStopMarker();
				} else { // 普通模式
					// 显示区域
					this.$MapService.setOverlayAreaPolygons(Array.from(this.areas).map(this.drawArea));
          this.drawArea2()
					// 显示站点
					this.$MapService.setOverlayStopMarkers(Array.from(this.stops).map(this.drawStop));
					// 清空车辆显示
					this.$MapService.removeOverlayBusMarker();
					// 清空运行中上车站显示
					this.$MapService.removeOverlayRunningOnStopMarker();
					// 清空运行中下车站显示
					this.$MapService.removeOverlayRunningOffStopMarker();
					// 触发上车站显示
					this.onStopTrigger(this.onStop);
					// 触发下车站显示
					this.offStopTrigger(this.offStop);
				}
				this.userPosTrigger(this.userPos);
			}
		},
		compassHeading(heading) {
			if (heading) {
				this.$MapService.setOverlayUserPosMarkerHeading(heading);
			}
		},
		mapMarginsBottom() {
			this.setUserPosCtrlBottom(this.mapMargins[2] - 20);
			// this.setFitViewCtrlBottom(this.mapMargins[2] + 30);
			if (this.mapVisible) {
				delay(() => {
					this.setFitView();
				});
			}
		},
		areas: {
			immediate: true,
			deep: true,
			handler(areas) {
				if (areas && map && !this.$MapService.isMapModeRunning()) {
					this.$MapService.removeOverlayAreaPolygons();
					this.$MapService.setOverlayAreaPolygons(Array.from(areas).map(this.drawArea));
				} else {
					try {
						this.$MapService.removeOverlayAreaPolygons();
					} catch (e) {
						console.log('[areas watch] removeOverlayAreaPolygons error', e);
					}
				}
			}
		},
		stops(stops) {
			if (map && !this.$MapService.isMapModeRunning()) {
				this.$MapService.setOverlayStopMarkers(Array.from(stops).map(this.drawStop));
			}
		},
		onStop: {
			immediate: true,
			deep: true,
			handler(obj) {
				this.onStopTrigger(obj);
			}
		},
		offStop: {
			immediate: true,
			deep: true,
			handler(obj) {
				this.offStopTrigger(obj);
			}
		},
		busPos: {
			immediate: true,
			deep: true,
			handler(obj) {
				this.busTrigger(obj);
			}
		},
		userPos: {
			immediate: true,
			deep: true,
			handler(obj) {
				this.userPosTrigger(obj);
			}
		},
		runningOnStop: {
			immediate: true,
			deep: true,
			handler(obj) {
				this.runningOnStopTrigger(obj);
			}
		},
		runningOffStop: {
			immediate: true,
			deep: true,
			handler(obj) {
				this.runningOffStopTrigger(obj);
			}
		},
		overlayOnStopLabel: {
			immediate: false,
			deep: false,
			handler(label) {
				if (label && this.overlayOnStopMarker) {
					this.overlayOnStopMarker.setLabel(label);
				}
			}
		},
		overlayOffStopLabel: {
			immediate: false,
			deep: false,
			handler(label) {
				if (label && this.overlayOffStopMarker) {
					this.overlayOffStopMarker.setLabel(label);
				}
			}
		},
		overlayRunningOnStopLabel: {
			immediate: false,
			deep: false,
			handler(label) {
				if (label && this.overlayRunningOnStopMarker) {
					this.overlayRunningOnStopMarker.setLabel(label);
				}
			}
		},
		overlayRunningOffStopLabel: {
			immediate: false,
			deep: false,
			handler(label) {
				if (label && this.overlayRunningOffStopMarker) {
					this.overlayRunningOffStopMarker.setLabel(label);
				}
			}
		},
    currentArea() {
      this.drawArea2()
    },
		runningRoute: {
			deep: true,
			handler(obj) {
				// console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~runningroute变化啦~', obj)
				this.runningRouteTrigger(obj);
			}
		},
		runningNaviStop: {
			deep: true,
			handler(obj) {
				this.runningNaviStopTrigger(obj);
			}
		},
		hideUserPosCtrl: {
			immediate: true,
			handler(val) {
				if (userPosCtrl) {
					val ? userPosCtrl.hide() : userPosCtrl.show();
				}
			}
		},
		fitViewToUserPos: {
			immediate: true,
			handler(val) {
				if (val) {
					userPosCtrl && userPosCtrl.click();
				}
			}
		},
		removeMarkerLabel: {
			immediate: true,
			handler(val) {
				if (val) {
					this.removeLabel2()
					this.setRemoveMarkerLabel(false)
				}
			}
		},
	},
	mounted() {
		this.init();
	},
	methods: {
    ...mapMutations({
      setRemoveMarkerLabel: 'setRemoveMarkerLabel'
    }),
		onClickInitCompass() {
			this.$MapService.getCompassHeading();
		},
		init() {
			this.$nextTick(() => {
				this.$MapService.setMapFitViewModeA();
				this.createMap();
				this.setMapStyle();
				// this.getLocation();
				this.loopUserPos();
				// 监控障碍物
				this.observeObstructions();
				// 初始化图标
				this.createSingleMarkers();
				// 初始化用户当前位置控件
				this.initUserPosControl();
				// 初始化全局视野控件
				// this.initFitViewControl();
				this.fitViewport();
				// 绑定事件
				this.bindEvents();
				// if (this.areaCenterPos && !this.onStop) {
				// 	let onStop = this.$MapService.findNearestStopByPos(this.areaCenterPos);
				// 	if (onStop) {
				// 		this.$MapService.setMapDataOnStop({point: onStop});
				// 	}
				// }
				// this.$MapService.setStateOnStopDraggable(true);
				wait(1000).then(() => {
					this.setFitView();
					this.onClickInitCompass();
				});
			});
		},
		bindEvents() {
			if (map && !eventBinded) {
				// 开始拖拽地图
				map.addEventListener('dragstart', this.onMapDragStart);
				// 推拽中
				map.addEventListener('dragging', this.onMapDragMove);
				// 停止拖拽地图
				map.addEventListener('dragend', this.onMapDragEnd);
			}
			eventBinded = true;
		},
		onStopTrigger(obj) {
			if (obj) {
				let {id, point, lng, lat, name, warn} = obj;
				if (point && !this.$PoiService.isStopTypeOff()) {
					if (this.$MapService.isMapModeRunning()) {
						return;
					}
          setTimeout(() => {
            let onStopMarker = this.showSingleMarker('onStop');
            onStopMarker && onStopMarker.setPosition(point);
            let desc = this.$MapService.isOnStopDraggable() ? '拖拽可更换上车站点' : '';
            if (!id) {
              desc = '';
              name = warn;
            }
            this.$MapService.removeOverlayOnStopLabel();
            this.$MapService.setOverlayOnStopLabel(this.setOnStopLabel({
              id,
              warn,
              name,
              desc,
              lng,
              lat
            }));
          }, 50)

				} else {
					if (map && this.overlayOnStopMarker) {
						map.removeOverlay(this.overlayOnStopMarker);
					}
				}
			}
		},
		offStopTrigger(obj) {
			if (obj) {
				let {id, point, lng, lat, name, warn} = obj;
				if (point) {
					if (this.$MapService.isMapModeRunning()) {
						return;
					}
          setTimeout(() => {
            let offStopMarker = this.showSingleMarker('offStop');
            offStopMarker && offStopMarker.setPosition(point);
            let desc = this.$MapService.isOffStopDraggable() ? '拖拽可更换下车站点' : '';
            if (id === 0) {
              desc = '';
              name = warn;
            }
            this.$MapService.removeOverlayOffStopLabel();
            this.$MapService.setOverlayOffStopLabel(this.setOffStopLabel({
              id,
              warn,
              name,
              desc,
              lng,
              lat
            }));
          }, 50)

				}
			} else {
				if (map && this.overlayOffStopMarker) {
					map.removeOverlay(this.overlayOffStopMarker);
				}
			}
		},
		busTrigger(obj) {
			if (obj) {
				if (!this.$MapService.isMapModeRunning()) {
					if (map && this.overlayBusMarker) {
						map.removeOverlay(this.overlayBusMarker);
					}
					return;
				}
				const { point, isArrive, isTimeoutArrive, license, onTime } = obj;
				let labelContent = '';
				if (isTimeoutArrive || isArrive) {
					const label = isTimeoutArrive ? '已超时等候' : '已到站';
					labelContent = `
						<div class="bubble">
							<div class="right">
								<div class="title">${license}</div>
								<div class="desc">${label}</div>
							</div>
							<img src="${posMarkerPic2}" class="pos" />
						</div>
					`;
				}  else {
					const diffTime = calcTimeDiff(onTime);
					if (diffTime) {
						labelContent = `
							<div class="bubble offset">
								<div class="right">
									<div class="title">${license}</div>
									<div class="desc time">约${diffTime}</div>
								</div>
								<img src="${posMarkerPic2}" class="pos" />
							</div>
						`;
					}
				}
				if (point) {
          setTimeout(() => {
            let busMarker = this.showSingleMarker('bus');
            busMarker && busMarker.setPosition(point);
            if (labelContent) {
              busMarker && busMarker.setLabel(new BMapGL.Label(labelContent, {
                position: point,
                offset: isTimeoutArrive ? new BMapGL.Size(-48, -58) : new BMapGL.Size(-30, -58)
              }))
            } else {
              busMarker && busMarker.setLabel(null)
            }
          }, 200)
					return;
				}
			}
			if (map && this.overlayBusMarker) {
				map.removeOverlay(this.overlayBusMarker);
			}
		},
		userPosTrigger(obj) {
			if (obj) {
				let [lng, lat] = obj || [];
				if (lng && lat) {
          setTimeout(() => {
            let userMarker = this.showSingleMarker('user');
            userMarker && userMarker.setPosition(new BMapGL.Point(lng, lat));
          }, 50)
				}
			}
		},
		runningOnStopTrigger(obj) {
			if (obj) {
				if (!this.$MapService.isMapModeRunning()) {
					if (map && this.overlayRunningOnStopMarker) {
						map.removeOverlay(this.overlayRunningOnStopMarker);
					}
					return;
				}
				const {point, lng, lat, name} = obj;
				if (point) {
					if (this.$OrderService.isOrderDispatching()) {
						if (!this.overlayPosingLabel) {
							let marker = new BMapGL.Marker(point, {
								icon: new BMapGL.Icon(nothingPic, sizeOne),
								zIndex: 10
							});
							this.$MapService.setOverlayPosingLabel(marker);
						}
						this.$nextTick(() => {
							if (!this.overlayPosingLabel.getLabel()) {
								this.overlayPosingLabel.setLabel(new BMapGL.Label(`<div class="wave wave-0"></div><div class="wave wave-1"></div><div class="wave wave-2"></div>`));
							}
							this.addOverlay(this.overlayPosingLabel);
						});
					} else {
						this.$MapService.removeOverlayPosingLabel();
					}
          setTimeout(() => {
            let onStopMarker = this.showSingleMarker('runningOnStop');
            onStopMarker && onStopMarker.setPosition(point);
            this.$MapService.removeOverlayRunningOnStopLabel();
            this.setRunningOnStopLabel({
              name,
              lng,
              lat
            });
          }, 50)
					return;
				}
			}
			if (map && this.overlayRunningOnStopMarker) {
				map.removeOverlay(this.overlayRunningOnStopMarker);
			}
		},
		runningOffStopTrigger(obj) {
			if (obj) {
				if (!this.$MapService.isMapModeRunning()) {
					if (map && this.overlayRunningOffStopMarker) {
						map.removeOverlay(this.overlayRunningOffStopMarker);
					}
					return;
				}
				const {point, name, lng, lat} = obj;
				if (point) {
          setTimeout(() => {
            let offStopMarker = this.showSingleMarker('runningOffStop');
            offStopMarker && offStopMarker.setPosition(point);
            this.$MapService.removeOverlayRunningOffStopLabel();
            this.setRunningOffStopLabel({
              name,
              lng,
              lat
            });
          }, 50)
					return;
				}
			}
			if (map && this.overlayRunningOffStopMarker) {
				map.removeOverlay(this.overlayRunningOffStopMarker);
			}
		},
		setOnStopLabel({id, name, desc, lng, lat, warn}) {
			return this.createLabel({
				id,
				warn,
				name,
				desc,
				type: 'on',
				opts: {
					position: new BMapGL.Point(lng, lat),
					offset: new BMapGL.Size(0, 0)
				}
			});
		},
		setOffStopLabel({id, name, desc, lng, lat}) {
			return this.createLabel({
				id,
				name,
				desc,
				type: 'off',
				opts: {
					position: new BMapGL.Point(lng, lat),
					offset: new BMapGL.Size(0, 0)
				}
			});
		},
		setRunningOnStopLabel({name, desc, lng, lat}) {
			if (this.overlayRunningOnStopLabel) {
				return;
			}
			this.$MapService.setOverlayRunningOnStopLabel(this.createLabel({
				name,
				desc,
				type: 'on',
				opts: {
					position: new BMapGL.Point(lng, lat),
					offset: new BMapGL.Size(0, 0)
				}
			}));
		},
		setRunningOffStopLabel({name, desc, lng, lat}) {
			if (this.overlayRunningOffStopLabel) {
				return;
			}
			this.$MapService.setOverlayRunningOffStopLabel(this.createLabel({
				name,
				desc,
				type: 'off',
				opts: {
					position: new BMapGL.Point(lng, lat),
					offset: new BMapGL.Size(0, 0)
				}
			}));
		},
		getMapCenter() {
			let  {lng, lat} = map.getViewport().center;
			return {lng, lat};
		},
		onMapDragStart() {
			if (!this.stateOnStopDraggable && !this.stateOffStopDraggable) {
				return;
			}
			if (this.stateOnStopDraggable) {
				this.$MapService.setStateDraggingOn(true);
				this.$MapService.removeOverlayOnStopLabel();
			}
			if (this.stateOffStopDraggable) {
				this.$MapService.setStateDraggingOff(true);
				this.$MapService.removeOverlayOffStopLabel();
			}
		},
		onMapDragMove() {
			if (!this.stateOnStopDraggable && !this.stateOffStopDraggable) {
				return;
			}
			let {lng, lat} = this.getMapCenter();
			let point = new BMapGL.Point(lng, lat);
			if (this.stateOnStopDraggable) {
				this.$MapService.removeOverlayOnStopLabel();
				this.$MapService.setMapDataOnStop(Object.assign({}, this.onStop, {point}));
			}
			if (this.stateOffStopDraggable) {
				this.$MapService.removeOverlayOffStopLabel();
				this.$MapService.setMapDataOffStop(Object.assign({}, this.offStop, {point}));
			}
		},
		onMapDragEnd() {
			if (!this.stateOnStopDraggable && !this.stateOffStopDraggable) {
				return;
			}
			this.$MapService.setStateDraggingOn(false);
			this.$MapService.setStateDraggingOff(false);
			let {lng, lat} = this.getMapCenter();
			let outOfRange = this.$MapService.isPointOutOfRange(new BMapGL.Point(lng, lat));
			let nearestStop = this.$MapService.findNearestStopByPos({lng, lat});
			if (!nearestStop) {
				return;
			}
			let {name} = nearestStop || {};
			if (this.stateOnStopDraggable) {
				this.$MapService.setStateOnStopDraggable(false);
				this.$MapService.setStateOffStopDraggable(false);
				if (outOfRange) {
					let point = new BMapGL.Point(lng, lat);
					this.$MapService.removeOverlayOnStopLabel();
					this.$MapService.setMapDataOnStop(Object.assign({id: 0, lng, lat, point, warn: '请拖动地图到蓝色区域选择站点'}));
					this.$MapService.setStateOnStopDraggable(true);
					this.$MapService.removeOverlayOnStopLabel();
				} else {
					let stop = Object.assign({}, this.onStop, nearestStop, {point: nearestStop});
					let {id} = stop;
					this.$MapService.setMapDataOnStop(stop);
					this.$MapService.setStateOnStopDraggable(true);
					this.$MapService.removeOverlayOnStopLabel();
					this.$MapService.setOverlayOnStopLabel(this.setOnStopLabel({
						id,
						name,
						desc: this.$MapService.isOnStopDraggable() ? '拖拽可更换上车站点' : '',
						lng,
						lat
					}));
					if (this.clickLabel && id === this.clickLabel.stopId) {
						this.removeLabel2()
					}
					// this.$MapService.setFitView([this.onStop], false);
					wait(60).then(() => {
						map.setCenter(this.onStop.point);
					});
				}
			}
			if (this.stateOffStopDraggable) {
				this.$MapService.setStateOnStopDraggable(false);
				this.$MapService.setStateOffStopDraggable(false);
				if (outOfRange) {
					this.$MapService.setDragNearestOffStop(null);
					let point = new BMapGL.Point(lng, lat);
					this.$MapService.setMapDataOffStop({id: 0, lng, lat, point, warn: '请拖动地图到蓝色区域选择站点'});
					this.$MapService.setStateOffStopDraggable(true);
					this.$MapService.removeOverlayOffStopLabel();
				} else {
					let stop = Object.assign({}, this.offStop, nearestStop, {point: nearestStop});
					let {id} = stop;
					this.$MapService.setMapDataOffStop(stop);
					this.$MapService.setStateOffStopDraggable(true);
					this.$MapService.setDragNearestOffStop(stop);
					this.$MapService.removeOverlayOffStopLabel();
					this.$MapService.setOverlayOffStopLabel(this.setOffStopLabel({
						id,
						name,
						desc: this.$MapService.isOffStopDraggable() ? '拖拽可更换下车站点' : '',
						lng,
						lat
					}));
					wait(60).then(() => {
						map.setCenter(this.offStop.point);
					});
				}
			}
		},
		panToUserPos() {
			this.$MapService.setMapFitViewModeB();
			delay(() => {
				this.setFitView();
			});
			// if (this.userPos) {
			// 	this.$MapService.panToUserPos();
			// } else {
			// 	this.fitViewport();
			// }
		},
		fitViewport() {
			this.setFitView();
		},
		observeObstructions() {
			this.$nextTick(() => {
				// 获取所有障碍物
				const obstructions = document.querySelectorAll('.map-obstruction');
				let setMapMarginBottom = this.$MapService.setMapMarginBottom;
				Array.from(obstructions).forEach(observeEl => {
					function mutationObserverCallback() {
						setMapMarginBottom(observeEl.clientHeight);
					}
					let MutationObserver = window.MutationObserver || window.WebkitMutationObserver || window.MozMutationObserver;
					let observer = new MutationObserver(mutationObserverCallback);
					observer.observe(observeEl, { attributes: true, childList: true, subtree: true });
				});
			});
		},
		createMap() {
			if (!map) {
				map = new BMapGL.Map('main-map',{
					minZoom: 10,
					enableRotateGestures: false,
					enableTiltGestures: false
				});
			}
			this.$nextTick(() => {
				this.$MapService.setMapInstance(map);
				// map.reset();
			});
		},
		setFitView() {
			this.$MapService.setFitView();
		},
		setMapStyle() {
			if (!map) {
				return;
			}
			map.setMapStyleV2({
				styleId: 'e262325226d430c4c9c7cb589c4ae485'
			});
		},
		setViewport(points, opt) {
			if (!map) {
				return;
			}
			map.setViewport(points.filter(p => !!p), opt);
		},
		initUserPosControl() {
			try {
				this.createUserPosControl();
				map.addControl(userPosCtrl);
				this.setUserPosCtrlBottom(this.mapMargins[2] - 20);
			} catch (e) {
				console.log(e);
			}
		},
		createUserPosControl() {
			let vm = this;
			// 切换到用户位置控件
			function UserPosControl() {
				// eslint-disable-next-line no-undef
				this.defaultAnchor = BMAP_ANCHOR_BOTTOM_RIGHT;
				this.defaultOffset = new BMapGL.Size(10, 10);
			}
			UserPosControl.prototype = new BMapGL.Control();
			UserPosControl.prototype.initialize = function(map) {
				let div = document.createElement('div');
				div.setAttribute('id', 'user-pos');
				div.setAttribute('class', 'user-pos');
				div.onclick = function () {
					vm.panToUserPos();
				};
				map.getContainer().appendChild(div);
				return div;
			};
			UserPosControl.prototype.click = function() {
				vm.panToUserPos();
			};
			// 隐藏控件
			UserPosControl.prototype.hide = function() {
				let el = document.getElementById('user-pos');
				if (el) {
					el.style.opacity = 0;
					el.style.zIndex = -1;
				}
			};
			// 显示控件
			UserPosControl.prototype.show = function() {
				let el = document.getElementById('user-pos');
				if (el) {
					el.style.opacity = 1;
					el.style.zIndex = 100;
				}
			};
			userPosCtrl = new UserPosControl();
		},
		setUserPosCtrlBottom(bottom = 10) {
			if (userPosCtrl) {
				userPosCtrl.setOffset(new BMapGL.Size(10, bottom));
			}
		},
		initFitViewControl() {
			try {
				this.createFitViewControl();
				map.addControl(fitViewCtrl);
				this.setFitViewCtrlBottom(this.mapMargins[2] + 30);
			} catch (e) {
				console.log(e);
			}
		},
		createFitViewControl() {
			let vm = this;
			// 全局视野控件
			function FitViewControl() {
				// eslint-disable-next-line no-undef
				this.defaultAnchor = BMAP_ANCHOR_BOTTOM_RIGHT;
				this.defaultOffset = new BMapGL.Size(10, 10);
			}
			FitViewControl.prototype = new BMapGL.Control();
			FitViewControl.prototype.initialize = function(map) {
				let div = document.createElement('div');
				div.setAttribute('class', 'fit-view');
				div.onclick = function () {
					vm.setFitView();
				};
				map.getContainer().appendChild(div);
				return div;
			};
			fitViewCtrl = new FitViewControl();
		},
		setFitViewCtrlBottom(bottom = 50) {
			if (userPosCtrl) {
				fitViewCtrl.setOffset(new BMapGL.Size(10, bottom));
			}
		},
		hideMarker(marker) {
			if (marker) {
				marker.setIcon(new BMapGL.Icon(nothingPic, new BMapGL.Size(1, 1)));
			}
		},
		showSingleMarker(key) {
			const {
				marker,
				icon,
				offset,
				zIndex
			} = singleMarkers[key];
			if (marker) {
				marker.setIcon(icon);
				if (offset) {
					marker.setOffset(offset);
				}
				marker.setZIndex(zIndex);
			}
			return marker;
		},
		createSingleMarkers() {
			let {lng, lat} = this.areaCenterPos || {};
			if (lng, lat) {
				o = new BMapGL.Point(lng, lat);
			}
			let isMapModeRunning = this.$MapService.isMapModeRunning();
			Object.entries(singleMarkers).filter(sm => {
				let [name] = sm;
				return isMapModeRunning ? ['bus', 'runningOnStop', 'runningOffStop', 'user'].indexOf(name) !== -1 : ['onStop', 'offStop', 'user'].indexOf(name) !== -1;
			}).forEach(([key, value]) => {
				const {
					setter,
					initIcon: icon,
					offset
				} = value;
				const opt = Object.assign({}, {icon}, offset ? {offset} : {});
				if (singleMarkers[key].marker) {
					map.removeOverlay(singleMarkers[key].marker);
				}
				this.$MapService[setter](singleMarkers[key].marker = new BMapGL.Marker(o, opt));
				this.$nextTick(() => {
					this.addOverlay(singleMarkers[key].marker);
				});
			});
		},
		createPoint(lng, lat) {
			return new BMapGL.Point(lng, lat);
		},
		createMarker(point, opt) {
			return new BMapGL.Marker(point, opt);
		},
		createPolygon(path, polygonOptions) {
			return new BMapGL.Polygon(path, polygonOptions);
		},
		addOverlay(overlay) {
			if (map) {
				map.addOverlay(overlay);
			}
		},
		drawArea(area = []) {
			let path = area.map(point => new BMapGL.Point(...point));
			let polygonOptions = {
				strokeColor: "#006EFA",
				strokeWeight: 1,
				strokeOpacity: 1,
				fillColor: '#006EFA',
				fillOpacity: 0.08,
				enableClicking: false
			};
			let polygon = this.createPolygon(path, polygonOptions);
			this.addOverlay(polygon);
			return polygon;
		},
		drawArea2() {
			this.clearArea2()
      const {smallArea} = this.currentArea || {}
      if (!smallArea || !smallArea.length) {
        return
      }
			let path = smallArea.map(point => new BMapGL.Point(...point));
			let polygonOptions = {
				strokeColor: "#04B47C",
				strokeWeight: 1,
				strokeOpacity: 1,
				fillColor: '#04B47C',
				fillOpacity: 0.08,
				enableClicking: false
			};
			this.polygon = this.createPolygon(path, polygonOptions);
			this.addOverlay(this.polygon);
		},
    clearArea2() {
      if (this.polygon && map) {
        map.removeOverlay(this.polygon)
        this.polygon = null
      }
    },
		drawStop(stop) {
			const {
				lng,
				lat,
        price,
				isHubStop
			} = stop;
      const {smallArea} =  this.currentArea || {}
			let point = this.createPoint(lng, lat);
			let marker = this.createMarker(point, {
				icon: smallArea && smallArea.length ? price >= 0 && price !== null ? stopIconGreen: stopIcon : stopIcon,
				zIndex: 10
			});
      marker.addEventListener('click', () => {
        // e.domEvent.stopPropagation()
        // e.domEvent.cancelBubble = true
        if (this.stopType === 'off') return
				if (this.onStopId === stop.id) return
        const {stopId, label} = this.clickLabel || {}
        if (stopId === stop.id) {
          map && label && map.removeOverlay(label);
          this.clickLabel = {stopId: null, label: null}
        } else {
					// 枢纽站模式，枢纽站做上车点时，不支持点击选择上车点
					if ((this.isHubArea && this.isFromHub) || isHubStop) return
          map && label && map.removeOverlay(label);
          this.clickLabel = {
            stopId: stop.id,
            label: this.createLabel2(stop)
          }
          marker.setLabel(this.clickLabel.label)
          map.setViewport({
            center: new BMapGL.Point(lng, lat),
            zoom: 15
          })
        }
      })
			this.addOverlay(marker);
			return marker;
		},
		formatName(name) {
			let str = name
			const isWrap = name && name.length > 10
			if (isWrap) {
				str = name.length > 20 ? name.slice(0, 10) + '<br/>' + name.slice(10, 20) + '...' : name.slice(0, 10) + '<br/>' + name.slice(10, 20)
			}
			return str
		},
		createLabel(options = {}) {
			let {
				id,
				warn,
				name,
				desc,
				type,
				opts = {}
			} = options;
			const stopIcon = `<img class="type" src="${type === 'on' ? onMarkerPic: offMarkerPic}"/>`
			const isWrap = name && name.length > 10
			name = name ? `<div class="title">${this.formatName(name)}</div>` : '';
			desc = desc ? `<div class="desc">${desc}</div>` : '';
			let isMapModeRunning = this.$MapService.isMapModeRunning();
			warn = (!id && !isMapModeRunning) ? `<div class="link">回到运营区域 &gt;</div>` : '';
			let balloonClass = [name, desc, warn].filter(p => !!p).length > 1 ? 'balloon fat' : 'balloon';
			if (isWrap) {
				balloonClass += ' wrap'
			}
			let content = `
				<div class="${balloonClass}">
					<div class="left">${stopIcon}</div>
					<div class="line"></div>
					<div class="right">${name}${desc}${warn}</div>
				</div>`;
			let label = new BMapGL.Label(content, opts);
			if (!id && !isMapModeRunning) {
				label.addEventListener('click', () => this.onClickBackToArea(type));
			}
			return label;
		},
		onClickBackToArea(type) {
			this.$MapService.panToArea();
			let {lng, lat} = this.areaCenterPos;
			if (lng && lat) {
				let point = new BMapGL.Point(lng, lat);
				let stop = Object.assign({}, {lng, lat, point, id: -1});
				if (type === 'on') {
					// 把区域中心点设置为上车站坐标
					this.$MapService.setMapDataOnStop(stop);
				} else {
					// 把区域中心点设置为下车站坐标
					this.$MapService.setMapDataOffStop(stop);
				}
			}
		},
		getLocation() {
			return this.$MapService.getLocation();
			// return new Promise((resolve) => {
			// 	let vm = this;
			// 	let geolocation = new BMapGL.Geolocation({
			// 		maximumAge: 10, // 清除缓存
			// 	});
			// 	geolocation.getCurrentPosition(function(r) {
			// 		if (this.getStatus() === BMAP_STATUS_SUCCESS) {
			// 			const {lng, lat} = r.point || {};
			// 			if (lng && lat) {
			// 				vm.$MapService.setMapDataUserPos([lng, lat]);
			// 				resolve([lng, lat]);
			// 				return;
			// 			}
			// 			resolve(1);
			// 		}
			// 		resolve(2);
			// 	}, function(e) {
			// 		console.log('get location error', e);
			// 		resolve(3);
			// 	}, {enabledHighAccuracy: true});
			// });
		},
		async loopUserPos() {
			await this.getLocation();
			this.$MapService.getCompassHeading().then(heading => {
				this.compassHeading = heading;
			});
			wait(3000).then(() => {
				this.loopUserPos();
			});
		},
    // 点击站点气泡
		createLabel2(stop = {}) {
			let {
				name,
				lng,
        lat
			} = stop || {};
			name = name ? `<div class="title2">${this.formatName(name)}</div><div class="line"></div>` : '';
			let content = `<div class="balloon2">${name}<div class="info2">选中上车点</div></div>`;
			let label = new BMapGL.Label(content, {
					position: new BMapGL.Point(lng, lat),
					offset: new BMapGL.Size(0, 0)
      });

      label.addEventListener('click', () => {
        // e.domEvent.stopPropagation()
        // e.domEvent.cancelBubble = true
				this.removeLabel2()
        const onStop = {
          ...stop,
          point: new BMapGL.Point(lng, lat)
        }
        this.$MapService.setMapDataOnStop(onStop);
		    this.$MapService.setMapRenderFlag();
      });
			return label;
		},
		removeLabel2() {
			if (this.clickLabel.label) {
				map && map.removeOverlay(this.clickLabel.label);
				this.clickLabel = {stopId: null, label: null};
			}
		},
    // 绘制脊线
		runningRouteTrigger(route) {
      this.removeRunningRoute()
			if (!route || !this.$MapService.isMapModeRunning()) return

      const list = route.split(';').filter(str => str).map(el => {
        const lnglat = el.split(',')
        const pos =  marsToBaidu(lnglat[0], lnglat[1])
        return [pos.lng, pos.lat]
      })
      const routeData = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: { name: 'style' },
            geometry: {
              type: 'LineString',
              coordinates: list
            }
          }
        ]
      }
      const lineLayer = new BMapGL.LineLayer({
        style: {
            sequence: false,
            marginLength: 8,
            borderColor: '#999',
            strokeWeight: 10,
            strokeColor: '#02aa76',
            strokeTextureUrl: require('../../assets/img-v2/ic_map_line.png'),
            strokeTextureWidth: 16,
            strokeTextureHeight: 64
        }
      })
			console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~该渲染线路啦~~~~', routeData)
      lineLayer.setData(routeData);
      map.addNormalLayer(lineLayer);
      this.$MapService.setOverlayRunningPolyline(lineLayer)
    },
    removeRunningRoute() {
      const line = this.overlayRunningPolyline
      if(map && line) {
        map.removeNormalLayer(line);
        this.$MapService.removeOverlayRunningPolyline()
      }
    },
    // 绘制经停点
		runningNaviStopTrigger(stops) {
      this.removeRunningNaviStop()
			if (!stops || !stops.length || !this.$MapService.isMapModeRunning()) return

      const markerList = stops.map(stop => {
        const pos = marsToBaidu(stop.lng, stop.lat)
        const marker = new BMapGL.Marker(new BMapGL.Point(pos.lng, pos.lat), {
          icon: naviStopIcon,
        })
        map.addOverlay(marker)
        return marker
      })
      this.$MapService.setOverlayRunningNaviStopMarker(markerList)
		},
    removeRunningNaviStop() {
      const markers = this.overlayRunningNaviStopMarker
      if(map && markers && markers.length) {
        map.removeOverlay(markers);
        this.$MapService.removeOverlayRunningNaviStopMarker()
      }
    }
  }
};
</script>

<style scoped lang="scss">
	.main-map-wrap {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: -1;

		.data-bus {
			width: 0;
			height: 0;
			overflow: hidden;
			position: fixed;
			top: -200vmax;
			left: -200vmax;
			z-index: -1;
		}

		#main-map {
			width: 100%;
			height: 100%;
		}

		.map-actions {
			width: auto;
			height: auto;
			position: fixed;
			right: 10px;
			bottom: 300px;
			.user-pos {
				width: 38px;
				height: 38px;
				background-image: url("../../assets/img/reset-pos.png");
				background-size: 100%;
				background-repeat: no-repeat;
				background-position: center;
				background-color: #FCB814;
        margin-bottom: 15px;
			}
		}
	}
	::v-deep {
		@keyframes waveEffect {
			from {
				background-color: rgba(23, 146, 255, .2);
				transform: translate3d(-50%, -50%, 0) scale(0);
				opacity: 1;
			}
			to {
				background-color: rgba(23, 146, 255, 0);
				transform: translate3d(-50%, -50%, 0) scale(1);
				opacity: 1;
			}
		}
		.wave {
			width: 209px;
			height: 209px;
			background-color: #1792ff;
			border: 1px solid #75beff;
			border-radius: 50%;
			position: absolute;
			top: -8px;
			left: -1px;
			animation: waveEffect ease-in 5s infinite;
			z-index: -1;
			opacity: 0;
			&-0 {
				animation-delay: 0s;
			}
			&-1 {
				animation-delay: 1.2s;
			}
			&-2 {
				animation-delay: 2.4s;
			}
		}
		.BMapLabel {
			background-color: transparent!important;
			border: none!important;
			width: auto;
			height: 1px;
			left: -50%;
			position: relative;
		}
		.balloon {
			background-color: #ffffff;
			padding: 9px 16px 9px 10px;
			border-radius: 25px;
			font-family: PingFangSC, PingFang SC;
			text-align: center;
			transform: translate3d(-50%, 0, 0);
			margin-left: -2px;
			bottom: 72px;
			display: flex;
			align-items: center;
			z-index: 1;
			position: relative;
			box-shadow: 0px 0px 6px 0px #AEC4D1;

			&.fat {
				bottom: 84px;
			}

			&.fat.wrap {
				bottom: 104px;
			}

			&.wrap {
				bottom: 92px;
			}

			.left {
				position: relative;
				display: flex;
				align-items: center;
				padding-right: 6px;
			}
			.line {
				width: 1px;
				height: 18px;
				background: #DDDDDD;
			}
			.type {
				width: 24px;
				height: 24px;
				position: relative;
				z-index: 1;
			}
			.right {
				padding-left: 6px;
			}
			.title {
				height: 100%;
				display: flex;
				align-items: center;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 16px;
				color: #000000;
				line-height: 22px;
				max-width: 210px;
				position: relative;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}

			.desc {
				height: 9px;
				font-size: 10px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				line-height: 9px;
				margin-top: 4px;
				position: relative;
			}

			.link {
				color: #006EFA;
				height: 28px;
				line-height: 24px;
				margin-bottom: -10px;
				font-size: 14px;
				font-weight: 500;
			}
		}

    .balloon2 {
			background-color: #ffffff;
			padding: 0 16px;
			border-radius: 25px;
			font-family: PingFangSC, PingFang SC;
			text-align: center;
			transform: translate3d(-50%, 0, 0);
			margin-left: -2px;
			bottom: 60px;
			display: flex;
			align-items: center;
			z-index: 50;
			position: relative;
			box-shadow: 0px 0px 6px 0px #AEC4D1;

			.title2 {
				height: 100%;
				display: flex;
				align-items: center;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 16px;
				color: #000000;
				// line-height: 42px;
				max-width: 210px;
				position: relative;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				padding: 5px 8px 5px 0;
			}
      .info2 {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #006EFA;
				line-height: 42px;
				text-align: center;
				font-style: normal;
				padding-left: 8px;
      }
			.line {
				width: 1px;
				height: 18px;
				background: #DDDDDD;
			}
    }
		.user-pos {
			width: 36px;
			height: 36px;
			background-image: url("../../assets/img-v2/ic_location.png");
			background-size: 100%;
			background-repeat: no-repeat;
			background-position: center;
      // margin-bottom: 15px;
		}
		.fit-view {
			width: 35px;
			height: 35px;
			background-image: url("../../assets/img/fit-view.png");
			background-size: 22px;
			background-repeat: no-repeat;
			background-position: center;
			background-color: #ffffff;
			border-radius: 50%;
			filter: drop-shadow(0 0 3px rgba(0, 0, 0, .2));
		}
		.bubble {
			background-color: #ffffff;
			padding: 9px 16px 9px 10px;
			border-radius: 25px;
			font-family: PingFangSC, PingFang SC;
			text-align: center;
			bottom: 30px;
			z-index: 100;
			position: relative;
			box-shadow: 0px 0px 6px 0px #AEC4D1;
			margin-left: 0px;
			display: flex;
			justify-content: center;
			align-items: center;
			.left {
				padding-right: 6px;
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;
				&::after {
					content: '';
					position: absolute;
					width: 1px;
					background: #DDDDDD;
					right: 0;
					top: 4px;
					bottom: 2px;
				}
			}
			.icon {
				width: 24px;
				height: 24px;
			}
			.right {
				padding-left: 5px;
			}
			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 10px;
				color: #000000;
				line-height: 14px;
			}
			.desc {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #FE5959;
				line-height: 18px;
			}
			.time {
				color: #006EFA;
			}
			.pos {
				position: absolute;
				bottom: calc(-100% + 13px);
			}
			&.offset {
				padding: 6px 16px;
				margin-left: -12px;
				bottom: 26px;
			}
		}
	}
</style>
